
export default function ProgramsHeroSection() {
  return (
    <section 
      className="relative py-32 bg-gradient-to-br from-blue-50 to-indigo-100"
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=University%20students%20studying%20in%20modern%20library%20with%20books%20and%20laptops%2C%20diverse%20group%20engaged%20in%20academic%20research%2C%20contemporary%20educational%20environment%2C%20natural%20lighting%2C%20Chilean%20university%20setting%2C%20collaborative%20learning%20atmosphere%2C%20academic%20excellence%2C%20professional%20study%20space&width=1920&height=800&seq=programs-hero&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundBlendMode: 'overlay'
      }}
    >
      <div className="absolute inset-0 bg-blue-900/50"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Programas de <span className="text-blue-300">Bachillerato</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-blue-50 leading-relaxed max-w-3xl mx-auto">
            Descubre la diversidad de programas que ofrecen nuestras universidades participantes, 
            cada uno diseñado para desarrollar el <span className="font-semibold text-white">potencial académico</span> y 
            <span className="font-semibold text-white"> personal</span> de los estudiantes
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
              <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-flask-line text-white text-xl"></i>
              </div>
              <h3 className="font-semibold text-white mb-1">Ciencias</h3>
              <p className="text-blue-100 text-sm">Formación integral en ciencias básicas</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
              <div className="w-12 h-12 bg-purple-500 rounded-xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-book-open-line text-white text-xl"></i>
              </div>
              <h3 className="font-semibold text-white mb-1">Humanidades</h3>
              <p className="text-blue-100 text-sm">Desarrollo del pensamiento crítico</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
              <div className="w-12 h-12 bg-green-500 rounded-xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-tools-line text-white text-xl"></i>
              </div>
              <h3 className="font-semibold text-white mb-1">Ingeniería</h3>
              <p className="text-blue-100 text-sm">Base sólida en ciencias aplicadas</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
              <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-palette-line text-white text-xl"></i>
              </div>
              <h3 className="font-semibold text-white mb-1">Interdisciplinario</h3>
              <p className="text-blue-100 text-sm">Enfoque transversal integrado</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
